import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiPhoneUsedTooFrequentlyError } from '@/core/error/transport/tmApiPhoneUsedTooFrequentlyError'
import { EndpointsEnum } from '@/services/endpoints'

export const phoneUsedTooFrequentlyErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.registrationPhoneProvide,
  subCodes: ['registration.phone_used_too_frequently'],
  klass: TmApiPhoneUsedTooFrequentlyError,
}
